import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-50 border-t border-gray-200 pt-16 pb-8" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-62">
          {/* Brand Column */}
          <div data-id="element-63">
            <img src="https://www.wearhaus.net/uploaded%2Fimages%2FRedesign%2FWearHausDesigns-logo%201.png" alt="Wear Haus Designs" className="h-12 w-auto mb-6" data-id="element-64" />
            <p className="text-gray-600 mb-6" data-id="element-65">
              We Logo Your Life. Specializing in screen print, embroidery,
              direct to garment and textile laser etching.
            </p>
            <div className="flex space-x-4" data-id="element-66">
              <a href="#" className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-500 hover:text-wh-pink hover:border-wh-pink transition-all" data-id="element-67">
                <Facebook className="w-5 h-5" data-id="element-68" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-500 hover:text-wh-pink hover:border-wh-pink transition-all" data-id="element-69">
                <Instagram className="w-5 h-5" data-id="element-70" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-500 hover:text-wh-pink hover:border-wh-pink transition-all" data-id="element-71">
                <Twitter className="w-5 h-5" data-id="element-72" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div data-id="element-73">
            <h3 className="text-lg font-bold text-gray-900 mb-6" data-id="element-74">Contact Us</h3>
            <ul className="space-y-4" data-id="element-75">
              <li className="flex items-start" data-id="element-76">
                <MapPin className="w-5 h-5 text-wh-pink mt-1 mr-3 flex-shrink-0" data-id="element-77" />
                <span className="text-gray-600" data-id="element-78">
                  4425 West US 20, Suite 1<br data-id="element-79" />
                  LaGrange, Indiana 46761
                </span>
              </li>
              <li className="flex items-center" data-id="element-80">
                <Phone className="w-5 h-5 text-wh-pink mr-3 flex-shrink-0" data-id="element-81" />
                <a href="tel:260-463-7373" className="text-gray-600 hover:text-wh-pink transition-colors" data-id="element-82">
                  260-463-7373
                </a>
              </li>
              <li className="flex items-center" data-id="element-83">
                <Mail className="w-5 h-5 text-wh-pink mr-3 flex-shrink-0" data-id="element-84" />
                <a href="mailto:wearhaus@wearhaus.net" className="text-gray-600 hover:text-wh-pink transition-colors" data-id="element-85">
                  wearhaus@wearhaus.net
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-86">
            <h3 className="text-lg font-bold text-gray-900 mb-6" data-id="element-87">
              Business Hours
            </h3>
            <ul className="space-y-4" data-id="element-88">
              <li className="flex items-start" data-id="element-89">
                <Clock className="w-5 h-5 text-wh-yellow mt-1 mr-3 flex-shrink-0" data-id="element-90" />
                <div data-id="element-91">
                  <span className="block text-gray-900 font-medium" data-id="element-92">
                    Monday – Friday
                  </span>
                  <span className="text-gray-600" data-id="element-93">8:00 AM to 4:00 PM EST</span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-94">
                <Clock className="w-5 h-5 text-gray-300 mt-1 mr-3 flex-shrink-0" data-id="element-95" />
                <div data-id="element-96">
                  <span className="block text-gray-900 font-medium" data-id="element-97">
                    Saturday – Sunday
                  </span>
                  <span className="text-gray-600" data-id="element-98">Closed</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-99">
            <h3 className="text-lg font-bold text-gray-900 mb-6" data-id="element-100">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-101">
              {['Home', 'About Us', 'Services', 'Helpful Info', 'Products', 'Contact'].map(item => <li key={item} data-id="element-102">
                  <a href="#" className="text-gray-600 hover:text-wh-pink transition-colors flex items-center" data-id="element-103">
                    <span className="w-1.5 h-1.5 bg-wh-teal rounded-full mr-2" data-id="element-104"></span>
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-105">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-106">
            © {new Date().getFullYear()} Wear Haus Designs. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-107">
            <a href="#" className="hover:text-wh-pink transition-colors" data-id="element-108">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-wh-pink transition-colors" data-id="element-109">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}